<template>
  <div class="intro-content">
    <v-container>

      <!-- Page 2 -->
      <h1>{{ head2 }}</h1>
      <p>{{ text2 }}</p>
      <table id="intro2table" class="table">
        <thead>
        <tr>
          <th v-for="header in table2head" :key="header.id" :class="header.class">{{ header.contents }}</th>
        </tr>
        </thead>
        <tfoot>
        <tr>
          <th v-for="header in table2head" :key="header.id" :class="header.class">{{ header.contents }}</th>
        </tr>
        </tfoot>
        <tbody>
        <tr v-for="(rows, index) in table2labels" :key="rows.id">
          <td colspan="5" class="header" width="100%" v-if="rows.row === 'header'">
            <div>{{ rows.labels }}</div>
          </td>
          <td v-if="rows.row !== 'header'" class="colorA">
            <div class="marginleft">{{ rows.labels }}</div>
          </td>
          <td class="centered colorB" v-if="rows.row !== 'header'">
            <v-icon v-if="table2col1details[index].contents" color="black">fa fa-check</v-icon>
          </td>
          <td class="centered colorB" v-if="rows.row !== 'header'">
            <v-icon v-if="table2col2details[index].contents" color="black">fa fa-check</v-icon>
          </td>
          <td class="centered colorC" v-if="rows.row !== 'header'">
            <v-icon v-if="table2col3details[index].contents" color="black">fa fa-check</v-icon>
          </td>
          <td class="centered colorC" v-if="rows.row !== 'header'">
            <v-icon v-if="table2col4details[index].contents" color="black">fa fa-check</v-icon>
          </td>
        </tr>
        </tbody>
      </table>
    </v-container>
  </div>
</template>

<script>
export default {
  data () {
    return {
      head2: "How is the Survey Organized?",
      text2:
        "The questionnaire starts with a few general questions about your funding totals, followed by more specific breakouts of the data you provide at the beginning. The table below shows the years and type of R&D funding requested within each question.",
      table2head: [
        { id: "1", contents: "Question number and topic", class: "colorA border-noleft" },
        { id: "2", contents: "FY 2023 R&D conduct", class: "colorB" },
        { id: "3", contents: "FY 2023 R&D plant", class: "colorB" },
        { id: "4", contents: "FY 2024 R&D conduct", class: "colorC" },
        { id: "5", contents: "FY 2024 R&D plant", class: "colorC border-noright" }
      ],
      table2labels: [
        { sect: "1", row: "header", labels: "R&D Totals" },
        { sect: "1", row: "1", labels: "1.  Outlays (totals)" },
        {
          sect: "1",
          row: "2",
          labels: "2.  Comparison with OMB Circular A-11 Schedule C"
        },
        { sect: "1", row: "3", labels: "3.  Obligations (totals)" },
        { sect: "1", row: "4", labels: "4.  Deobligations (totals)" },
        { sect: "2", row: "header", labels: "Breakdowns of R&D obligations" },
        { sect: "2", row: "5", labels: "5.  By type of work" },
        {
          sect: "2",
          row: "6",
          labels: "6.  By type of work and by detailed field of R&D"
        },
        {
          sect: "2",
          row: "7",
          labels: "7.	 By type of work and by broad field of R&D"
        },
        { sect: "2", row: "8", labels: "8.	By type of work and performer" },
        { sect: "2", row: "9", labels: "9.  By type of work and performer" },
        {
          sect: "2",
          row: "10",
          labels: "10. Nonfederal R&D by type of agreement"
        },
        {
          sect: "2",
          row: "11",
          labels: "11. R&D agreements with other federal agencies"
        },
        {
          sect: "2",
          row: "12",
          labels: "12. R&D conduct by performer and state"
        },
        {
          sect: "2",
          row: "13",
          labels: "13. R&D plant by performer and state"
        },
        {
          sect: "2",
          row: "14",
          labels: "14. To non-U.S. performers by country" },
        {
          sect: "2",
          row: "15",
          labels: "15.	To U.S. higher education by type of work and detailed field of R&D"
        },
        {
          sect: "2",
          row: "16",
          labels: "16. To specific FFRDCs by type of work"
        },
        {
          sect: "2",
          row: "17",
          labels: "17.	To specific UARCs by type of work"
        },
        {
          sect: "3",
          row: "header",
          labels: "R&D and S&E Support"
        },
        {
          sect: "3",
          row: "18",
          labels: "18.	To specific U.S. higher education institutions"
        },
        {
          sect: "3",
          row: "19",
          labels: "19.	To specific U.S. nonprofit organizations"
        },
        { sect: "4", row: "header", labels: "" }
      ],
      table2col1details: [
        { row: "0", contents: false },
        { row: "1", contents: true },
        { row: "2", contents: true },
        { row: "3", contents: true },
        { row: "4", contents: true },
        { row: "0", contents: false },
        { row: "5", contents: true },
        { row: "6", contents: true },
        { row: "7", contents: false },
        { row: "8", contents: true },
        { row: "9", contents: false },
        { row: "10", contents: true },
        { row: "11", contents: true },
        { row: "12", contents: true },
        { row: "13", contents: false },
        { row: "14", contents: true },
        { row: "15", contents: true },
        { row: "16", contents: true },
        { row: "17", contents: true },
        { row: "0", contents: false },
        { row: "18", contents: true },
        { row: "19", contents: true }
      ],
      table2col2details: [
        { row: "0", contents: false },
        { row: "1", contents: true },
        { row: "2", contents: true },
        { row: "3", contents: true },
        { row: "4", contents: true },
        { row: "0", contents: false },
        { row: "5", contents: false },
        { row: "6", contents: false },
        { row: "7", contents: false },
        { row: "8", contents: true },
        { row: "9", contents: false },
        { row: "10", contents: true },
        { row: "11", contents: true },
        { row: "12", contents: false },
        { row: "13", contents: true },
        { row: "14", contents: true },
        { row: "15", contents: false },
        { row: "16", contents: true },
        { row: "17", contents: true },
        { row: "0", contents: false },
        { row: "18", contents: true },
        { row: "19", contents: true }
      ],
      table2col3details: [
        { row: "0", contents: false },
        { row: "1", contents: true },
        { row: "2", contents: false },
        { row: "3", contents: true },
        { row: "4", contents: false },
        { row: "0", contents: false },
        { row: "5", contents: true },
        { row: "6", contents: false },
        { row: "7", contents: true },
        { row: "8", contents: false },
        { row: "9", contents: true },
        { row: "10", contents: false },
        { row: "11", contents: false },
        { row: "12", contents: false },
        { row: "13", contents: false },
        { row: "14", contents: false },
        { row: "15", contents: false },
        { row: "16", contents: false },
        { row: "17", contents: false },
        { row: "0", contents: false },
        { row: "18", contents: false },
        { row: "19", contents: false }
      ],
      table2col4details: [
        { row: "0", contents: false },
        { row: "1", contents: true },
        { row: "2", contents: false },
        { row: "3", contents: true },
        { row: "4", contents: false },
        { row: "0", contents: false },
        { row: "5", contents: false },
        { row: "6", contents: false },
        { row: "7", contents: false },
        { row: "8", contents: false },
        { row: "9", contents: true },
        { row: "10", contents: false },
        { row: "11", contents: false },
        { row: "12", contents: false },
        { row: "13", contents: false },
        { row: "14", contents: false },
        { row: "15", contents: false },
        { row: "16", contents: false },
        { row: "17", contents: false },
        { row: "0", contents: false },
        { row: "18", contents: false },
        { row: "19", contents: false }
      ]
    };
  }
};
</script>

<style scoped>
h1 {
  font-size: 22pt;
  font-weight: bold;
  margin-bottom: 12pt;
  margin-top: 12pt;
}
.left {
  text-align: left;
}
.centered {
  text-align: center;
}
ul,
p {
  text-align: left;
}
p {
  font-size: 12pt;
  font-weight: normal;
}
li {
  margin-bottom: 10pt;
}
.intro-content {
  color: #000;
  max-width: 1100px; /* to be consistent with other intro panels, but wider to better support table content */
}
.bordered {
  border: #000;
  border-width: 1px;
}
.header {
  font-weight: bold;
  color: black;
  font-size: 16px;
  margin: 0;
}

table {
  width: 100%;
  text-align: left;
  border-spacing: 0;
  border-collapse: collapse;
}

/* using ID to increase selector priority and avoid using !important on border styles */
#intro2table th {
  text-align: center;
  border-top: 1px solid gray;
  border-bottom: 2px solid gray;
  padding: 10px;
}
#intro2table tfoot th {
  border-top-width: 2px;
  border-bottom-width: 1px;;
}

#intro2table th.border-noleft {
  border-left: none;
}
#intro2table th.border-noright {
  border-right: none;
}

th.bottom {
  vertical-align: bottom;
}
.marginleft {
  margin-left: 5px;
}

#intro2table tbody tr:hover {
  border: 1px solid rgb(82, 82, 82);
  border-left-width: 2px;
  border-right-width: 2px;
}

#intro2table td {
  border-bottom: 1px solid gray;
  padding: 5px;
}

td.center {
  text-align: center;
}
td.top {
  vertical-align: top;
}

.colorA {
  background-color: #daeef3;
}

.colorB {
  background-color: #e2efda;
}

.colorC {
  background-color: #fff2cc;
}

</style>
